import { render } from "./template.vue?vue&type=template&id=19443cbc&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=19443cbc&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19443cbc"]])

export default __exports__